exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-num[data-v-c58178d0]{position:absolute;top:1rem;bottom:0;width:-webkit-max-content;width:max-content;cursor:pointer;font-size:.6rem;color:#ffc72b}.code-num-ltr[data-v-c58178d0]{right:.5rem}.code-num-rtl[data-v-c58178d0]{left:.5rem}.code-num.disabled[data-v-c58178d0],.code-num.disabled[data-v-c58178d0]:hover{cursor:no-drop;background:none!important;font-size:.6rem;color:#bcbcbc}.model[data-v-c58178d0]{position:fixed;top:0;width:100vw;height:100vh;background:rgba(0,0,0,.2);z-index:9999}.model[data-v-c58178d0] .van-icon{font-size:.9rem;color:#333;margin-right:1rem;float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c58178d0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/sendCode.vue
// module id = N9tf
// module chunks = 7 9